const escapeRegExp = value => value.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');

const isScalar = value => /string|number|boolean/.test(typeof value);

const Highlight = ({searchQuery, children, matchClass = 'highlight'}) => {
  if (!isScalar(children) || !searchQuery) {
    return <span>{children}</span>;
  }

  const text = String(children);
  const regex = new RegExp(escapeRegExp(String(searchQuery)), 'i');
  const segments = [];
  let remaining = text;
  let key = 0;

  while (remaining) {
    const match = regex.exec(remaining);
    if (!match) {
      segments.push(<span key={key++}>{remaining}</span>);
      break;
    }

    const index = match.index;
    const matched = match[0];

    if (index > 0) {
      segments.push(<span key={key++}>{remaining.slice(0, index)}</span>);
    }
    segments.push(<strong key={key++} className={matchClass}>{matched}</strong>);
    remaining = remaining.slice(index + matched.length);
  }

  return <span>{segments}</span>;
};

export default Highlight;
